module.exports = __webpack_public_path__ + "static/img/sabio-logo.8f314ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sabio-logo.png
// module id = OSiM
// module chunks = 1